import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import hexToRgba from 'hex-rgba';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  {
    week: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    day: {
      cursor: 'pointer',
      width: 44,
      height: 44,
      display: 'inline-block',
      lineHeight: '44px',
      textAlign: 'center',
      background: hexToRgba(color.$1, 30),
      color: color.$1,
    },
    active: {
      background: color.$1,
      color: color.$7,
    },
    first: {
      borderRadius: '10px 0 0 10px',
    },
    last: {
      borderRadius: '0 10px 10px 0',
    },
  },
  {
    name: 'WeekSchedule',
  },
);

const weekMenu = [1, 2, 3, 4, 5, 6, 0];

const sortDays = (a, b) => {
  return weekMenu.indexOf(a) - weekMenu.indexOf(b);
};

const WeekSchedule = ({ data, className, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const weekConmponent = useMemo(() => {
    return weekMenu.map(day => {
      const active = data.includes(day);
      return (
        <div
          key={`WeekSchedule-${day}`}
          className={classnames(classes.day, {
            [classes.active]: active,
            [classes.first]: day === 1,
            [classes.last]: day === 0,
          })}
          onClick={() => {
            if (active) {
              onChange([...data.filter(d => d !== day)].sort(sortDays));
            } else {
              onChange([...data, day].sort(sortDays));
            }
          }}
        >
          {t(`week${day}`)}
        </div>
      );
    });
  }, [data]);

  return (
    <div className={classnames(classes.week, className)}>{weekConmponent}</div>
  );
};

export default WeekSchedule;
